export default "__VITE_ASSET__BT30ovwF__"